import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ConstructsOverviewRoutingModule} from './constructs-overview-routing.module';
import {ConstructsOverviewComponent} from './constructs-overview.component';
import {ConstructsOverviewRepository} from './repositories/constructs-overview.repository';
import {ConstructsOverviewService} from './services/constructs-overview.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    ConstructsOverviewRoutingModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    ConstructsOverviewComponent,
  ],
  providers: [
    ConstructsOverviewService,
    ConstructsOverviewRepository,
  ],
})
export class ConstructsOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-overview/constructs-overview.module.ts